import { EmployeesFilterInput } from "@/Miscellaneous/interfaces/orgchart";
import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger, getError } from "@Common/helpers/logger";

export async function retrieveEmployeeListOrgChart(locationId: string, filter: EmployeesFilterInput) {
	const query = gql`
		query getEmployees($locationId: String!, $filter: EmployeesFilterInput) {
			getEmployees(locationId: $locationId, filter: $filter) {
				_id
				profilePicture
				fullName
				jobTitle
				supervisorId
				employeeId
				hireDate
				payrollSourceId {
					idValue
					idField
					displayId
					companyId
					providerName
				}
				communications {
					acceptsTxt
					communicationType
					usage
					value
				}
			}
		}
	`;
	const variables = {
		locationId,
		filter: {
			withProfilePicture: filter.withProfilePicture || false,
		},
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getEmployees;
	} catch (err) {
		errorLogger(getError(err), {
			function: "retrieveEmployeeListOrgChart",
			message: "Failed to retrieve employee list for organization chart.",
			variables,
		});
		return null;
	}
}
